import { useContext, useState } from 'react';
import Button from '../../components/button/button.component';
import { CartContext } from '../../contexts/cart.context';

// Les codes promo sont validés CÔTÉ SERVEUR (checkPromo.php) : aucune liste ici,
// donc rien n'est visible dans le bundle client. Cet endpoint plafonne aussi les
// tentatives par IP — d'où la réponse 429 { error: 'too_many_attempts' } traitée plus bas.
const CHECK_PROMO_URL = '/checkPromo.php';

const PromoCode = ({ setDiscount, setPromoCode, setFreeShipping }) => {
  const { cartTotal } = useContext(CartContext);

  const [infoCode, setInfoCode] = useState('');
  const [errorCode, setErrorCode] = useState('');
  const [userCodeInput, setUserCodeInput] = useState('');

  const handlePromoCode = async () => {
    try {
      const response = await fetch(CHECK_PROMO_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: userCodeInput })
      });
      const data = await response.json();

      if (data.valid && data.type === 'percent') {
        // Un nouveau code valide REMPLACE le précédent → on annule la livraison offerte.
        setErrorCode('');
        setFreeShipping(false);
        // Arrondi au centime AVANT affichage, à l'identique de getOrderId.php : sans ça
        // le total affiché peut différer d'un centime du montant réellement débité.
        const discount = Math.round(parseFloat(cartTotal) * data.percent) / 100;
        setDiscount(discount);
        setPromoCode(userCodeInput); // le serveur appliquera la remise au paiement
        setInfoCode(
          `Code de réduction appliqué: ${userCodeInput} -${data.percent}%`
        );
      } else if (data.valid && data.type === 'free_shipping') {
        // Remplace le précédent → on annule la remise en %.
        setErrorCode('');
        setDiscount(0);
        setFreeShipping(true);
        setPromoCode(userCodeInput); // le serveur mettra les frais de port à 0
        setInfoCode(`Livraison offerte appliquée: ${userCodeInput}`);
      } else if (data.error === 'too_many_attempts') {
        // Trop d'essais infructueux : checkPromo.php bloque temporairement cette IP.
        setErrorCode(
          'Trop de tentatives. Merci de patienter quelques minutes avant de réessayer.'
        );
      } else {
        // Code invalide → on ne touche PAS au message du code déjà appliqué.
        setErrorCode("Ce code de réduction n'existe pas");
      }
    } catch {
      // Erreur réseau/serveur → message d'erreur séparé, le code appliqué reste affiché.
      setErrorCode('Impossible de vérifier le code pour le moment, réessayez');
    }
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setUserCodeInput(value);
  };

  return (
    <div className="promo">
      <p className="promo-label">Code de réduction</p>

      <div className="promo-row">
        <input
          name="promo"
          value={userCodeInput}
          onChange={handleChange}
          placeholder="Saisir un code"
        />
        <Button
          disabled={!userCodeInput}
          onClick={handlePromoCode}
          className="promo-button"
        >
          Valider
        </Button>
      </div>

      {infoCode && <p className="promo-info">{infoCode}</p>}
      {errorCode && <p className="promo-error">{errorCode}</p>}
    </div>
  );
};

export default PromoCode;
